import { emailDomainAuthenticatorConstants } from "../constants/emailDomainAuthenticator.constants";

export function emailDomainAuthenticator(state = {}, action) {
  switch (action.type) {
    case emailDomainAuthenticatorConstants.GET_REQUEST:
    case emailDomainAuthenticatorConstants.GET_BYID_REQUEST:
    case emailDomainAuthenticatorConstants.CREATE_REQUEST:
    case emailDomainAuthenticatorConstants.UPDATE_REQUEST:
      return {
        ...state,
        loading: true,
        request: action.payload,
        error: false,
        success: false,
      };
    case emailDomainAuthenticatorConstants.GET_SUCCESS:
      return {
        ...state,
        loading: false,
        paginatedResult: action.payload,
      };
    case emailDomainAuthenticatorConstants.GET_BYID_SUCCESS:
      return {
        ...state,
        loading: false,
        byId: action.payload,
      };
    case emailDomainAuthenticatorConstants.CREATE_SUCCESS:
    case emailDomainAuthenticatorConstants.UPDATE_SUCCESS:
      return {
        ...state,
        loading: false,
        success: true,
      };
    case emailDomainAuthenticatorConstants.DELETE_REQUEST:
      return {
        ...state,
        loading: true,
        deleteSuccess: false,
      };
    case emailDomainAuthenticatorConstants.DELETE_SUCCESS:
      return {
        ...state,
        loading: false,
        deleteSuccess: true,
      };
    case emailDomainAuthenticatorConstants.CREATE_FAILURE:
    case emailDomainAuthenticatorConstants.GET_FAILURE:
    case emailDomainAuthenticatorConstants.GET_BYID_FAILURE:
    case emailDomainAuthenticatorConstants.DELETE_FAILURE:
    case emailDomainAuthenticatorConstants.UPDATE_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
      };
    default:
      return state;
  }
}
